import { DraftNote, UUID } from "@/core/types";
import { providerRequestsTyped } from "@/api/(requests)/providerTyped";

export async function getDraftNotes(providerId?: UUID): Promise<DraftNote[]> {
  return providerRequestsTyped.fetch_provider_draft_notes({
    data: providerId !== undefined ? { provider_id: providerId } : undefined,
  });
}
